import { htmlColor, createImage } from './tools.coffee'
import { colors, programs, buffers, drawShipModel } from './view.coffee'
import { gl, drawIcon } from './gl.coffee'

export class MainMenu
	constructor: (@data) ->
		pressEvent = undefined
		content = document.getElementsByTagName('main')[0]
		content.addEventListener 'mousedown', (ev) -> pressEvent = ev if ev.button == 0
		content.addEventListener 'mousemove', (ev) => if pressEvent
			@previewAngleZ -= (ev.clientX - pressEvent.clientX)*0.01
			@previewAngleX -= (ev.clientY - pressEvent.clientY)*0.01
			pressEvent = ev
		window.addEventListener 'mouseup', -> pressEvent = undefined
		@originX = 0
		@originY = 0
		@previewAngleX = 3.8
		@previewAngleZ = 3.3
		@prevTime = Date.now()

	setData: (@data) ->
		document.getElementById('name').value = @data.name
		buffers.spaceships.parts.forEach (part, type) =>
			sb = document.createElement 'div'
			sb.onclick = => @selectShip type
			sb.appendChild createImage drawIcon(128, 128, -> drawShipModel(type, 6, 4)).toDataURL()
			document.getElementById('ships').appendChild sb
		@selectShip @data.ship
		colors.hull.forEach (colors, part) =>
			group = document.createElement 'div'
			colors.forEach (color, i) =>
				cb = document.createElement 'div'
				cb.onclick = => @selectColor part, i
				cb.style.background = htmlColor color
				group.appendChild cb
			document.getElementById('colors').appendChild group
			@selectColor part, @data["color#{part}"]

	select: (group, name, value) ->
		value = 0 if not group[value]?
		group[@data[name]]?.className = ''
		group[@data[name] = value]?.className = 'sel'

	selectShip: (ship) -> @select document.getElementById('ships').children, 'ship', ship
	selectColor: (part, color) -> @select document.getElementById('colors').children[part].children, "color#{part}", color

	draw: (w, h) ->
		curTime = Date.now()
		deltaTime = curTime - @prevTime
		@originX += 0.00001*deltaTime
		@originY += 0.000001*deltaTime
		gl.clear gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT
		gl.disable gl.BLEND
		buffers.rect.use()
		vmin = Math.min w, h
		aspX = w/vmin
		aspY = h/vmin
		programs.parallax.use
			pos: [@originX, @originY]
			asp: [aspX, aspY]
		gl.drawArrays gl.TRIANGLES, 0, 6
		if @data
			gl.enable gl.DEPTH_TEST
			programs.mesh.use
				proj: Math.frustum aspX, aspY, 1, 100
				view: Math.euler4 @previewAngleX, @previewAngleZ, -3, 0, -0.1, -4
				type: (@data.color0*8 + @data.color1)/64
			buffers.spaceships.use()
			buffers.spaceships.drawPart @data.ship
			gl.disable gl.DEPTH_TEST
		@prevTime = curTime



// WEBPACK FOOTER //
// ./client/menu.coffee